export default __webpack_public_path__ + "static/media/cloudsFooter.31e5a0c6.webp";